import React from 'react';
import PropTypes from 'prop-types';

const IdelLink = ({ label, onClickHandle }) => (
    <div className='dashboard-measure-scores' data-test-id="idel-measure-scores">
        <div className='dashboard-measure-info'>
            <a className='dashboard-skill dashboard-app-link' href={window.location.href} onClick={onClickHandle}>
                <i className='dashboard-navigation-link-icon' />
                <span className='dashboard-measure-name dashboard-app-label'>{label}</span>
            </a>
        </div>
    </div>
);

IdelLink.propTypes = {
    label: PropTypes.string.isRequired,
    onClickHandle: PropTypes.func.isRequired,
};

export default IdelLink;
